var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"obspanel-toolbar",attrs:{"dark":"","dense":""}},[_c('v-btn',{attrs:{"icon":"","to":"/"}},[_c('v-icon',[_vm._v("mdi-close")])],1),_c('v-spacer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }